var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.44627 17.7652C7.05954 18.1627 6.42104 18.1717 6.0244 17.784C5.82053 17.5848 5.62184 17.3876 5.42794 17.1858C4.04376 15.7449 2.79673 14.196 1.77898 12.4716C1.06315 11.2589 0.495095 9.98568 0.197423 8.59867C-0.486867 5.41324 1.09186 2.27741 4.05617 0.95844C7.33481 -0.500504 11.2704 0.982183 12.7822 4.23885C13.5576 5.909 13.5703 7.61423 13.0816 9.36022C12.9821 9.71601 12.8403 9.86839 12.4544 9.91977C10.5536 10.1721 8.95215 11.6544 8.49502 13.5329C8.26467 14.4798 8.30826 15.4136 8.63393 16.3328C8.6637 16.4172 8.69453 16.488 8.61196 16.572C8.22432 16.9659 7.8388 17.3616 7.44627 17.7652ZM10.0567 7.08764C10.0567 5.24597 8.57156 3.75832 6.73344 3.75797C4.89461 3.75797 3.40271 5.24491 3.39987 7.0809C3.39704 8.92859 4.88894 10.4208 6.73521 10.417C8.58077 10.4131 10.0571 8.93355 10.0567 7.08764Z",
    fill: "url(#paint0_linear_502_105153)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00686 17.7652C6.39358 18.1627 7.03209 18.1717 7.42873 17.784C7.63259 17.5848 7.83128 17.3876 8.02519 17.1858C9.40936 15.7449 10.6564 14.196 11.6741 12.4716C12.39 11.2589 12.958 9.98568 13.2557 8.59867C13.94 5.41324 12.3613 2.27741 9.39696 0.95844C6.11832 -0.500505 2.18268 0.982183 0.670933 4.23885C-0.10443 5.909 -0.117188 7.61423 0.371489 9.36022C0.471067 9.71601 0.612816 9.86839 0.998726 9.91977C2.89957 10.1721 4.50097 11.6544 4.95811 13.5329C5.18845 14.4798 5.14486 15.4136 4.8192 16.3328C4.78943 16.4172 4.7586 16.488 4.84117 16.572C5.2288 16.9659 5.61433 17.3616 6.00686 17.7652ZM3.3964 7.08764C3.3964 5.24597 4.88157 3.75832 6.71969 3.75797C8.55852 3.75797 10.0504 5.24491 10.0533 7.0809C10.0561 8.92859 8.56419 10.4208 6.71791 10.417C4.87235 10.4131 3.39604 8.93355 3.3964 7.08764Z",
    fill: "url(#paint1_linear_502_105153)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.72537 9.3571C5.46912 9.35498 4.45917 8.34218 4.46094 7.08594C4.46236 5.83324 5.48011 4.81938 6.73423 4.8208C7.98906 4.82222 8.99795 5.83678 8.99547 7.0948C8.99299 8.35459 7.98516 9.35923 6.72537 9.3571Z",
    fill: "url(#paint2_linear_502_105153)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_502_105153",
    x1: -0.857842,
    y1: 2.96162,
    x2: 13.7828,
    y2: 16.4918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00754A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_502_105153",
    x1: 14.311,
    y1: 2.96162,
    x2: -0.329698,
    y2: 16.4918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00754A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_502_105153",
    x1: 4.15684,
    y1: 5.46405,
    x2: 7.75012,
    y2: 9.9539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00754A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation1);
export default __webpack_public_path__ + "static/media/location1.cd8b59aa7165c2443bd868ade87cdfbc.svg";
export { ForwardRef as ReactComponent };